//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import { translate } from "react-i18next";
import AdminPanel from './../content/grid/adminPanel/AdminPanel';
import styled from 'styled-components';
import Modal from './../../containers/content/modal/Modal';
import { Slide, ToastContainer } from 'react-toastify';

type State = {
};

type Props = {
    t: (s: string) => string,
    signOut: () => void,
};

const AdminWindow = styled.div`
    height: 100%;
    width: 100%;
`;

export class Admin extends React.Component<Props, State> {
    render(): React.Node {
        const { t, roles } = this.props;
        const isAdmin = roles === 'Admin' || roles === 'SuperAdmin'
            ? true
            : false;

        return (
            <AdminWindow>
                {isAdmin
                    ? <AdminPanel roles={roles} />
                    : <p>{`${t('You are not an admin')}!`}</p>
                }
                <Modal ref={(translatedNode) => {
                    if (translatedNode !== null) {
                        modalInstance = translatedNode.getWrappedInstance()
                    }
                }} />
                <ToastContainer
                    draggablePercent={60}
                    transition={Slide}
                />
            </AdminWindow>
        );
    }
};

const mapStateToProps = state => ({
    roles: state.auth.get('roles'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(Admin));

export let modalInstance: ModalInstance;


// WEBPACK FOOTER //
// ./src/containers/admin/Admin.jsx